import styled from 'styled-components';

export default styled.div`
  color: ${(props): string => props.className === 'error' ? 'red' : 'green'};;
  margin: 0.625rem 0;
`;